import CircularProgress from "@material-ui/core/CircularProgress";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React from "react";

export default function SelectableSearch(props) {
  const [open, setOpen] = React.useState(false);
  const loading = open && props.data.values.length === 0 ? true : false;

  React.useEffect(() => {
    let active = true;
    if (!loading) {
      return undefined;
    }
    if (active) {
      props.loading();
    }
    return () => {
      active = false;
    };
    //eslint-disable-next-line
  }, [loading]);

  return (
    <React.Fragment>
      <Autocomplete
        tabIndex={props.tabIndex}
        value={props.value}
        id={props.id}
        open={open}
        onOpen={() => {
          setOpen(true);
        }}
        onClose={() => {
          setOpen(false);
        }}
        onChange={props.onChangeEvent}
        getOptionLabel={(option) => {
          if (option && option.optionname) {
            return option.optionname;
          } else {
            return "";
          }
        }}
        options={
          props.data && props.data.values.length > 0 ? props.data.values : []
        }
        loading={props.data.load}
        renderInput={(params) => (
          <TextField
            {...params}
            label={props.label}
            autoFocus={props.autoFocus}
            required={props.required}
            variant={props.variantType ? props.variantType : "outlined"}
            name={props.name}
            onBlur={props.onBlur}
            error={props.error}
            helperText={props.helperText}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {props.data.load ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
    </React.Fragment>
  );
}
